export const getChartOptions = (data) => {
    const months = [...new Set(data.map(item => item.descripcion))].map(m => m.substring(0, 3));
  
    return {
      title: { 
        text: "Nfu Reportados VS Entregados", left: "center",
        padding: [20, 10, 10, 10],
        textStyle: {
            fontSize: Math.max(window.innerWidth * 0.02, 16), 
        },
       },
      tooltip: {
        trigger: "axis",
        textStyle: { fontSize: 10 },
        formatter: function (params) {
          const reportados = params.find(p => p.seriesName === "REPORTADOS").data;
          const entregados = params.find(p => p.seriesName === "ENTREGADOS").data;
          return `
            ${params[0].name}<br/>
            REPORTADOS: <b>${reportados} NFU</b><br/>
            ENTREGADOS: <b>${entregados} NFU</b><br/>
            DIFERENCIA: <b>${Math.abs(entregados - reportados)} NFU</b>
          `;
        }
      },
      legend: { bottom: 0 },
      xAxis: [{ type: "category", data: months, }],
      yAxis: [{
        type: "value",
        name: "NFU (UNIDADES)",
        nameLocation: "middle",
        nameTextStyle: { fontSize: 11, padding: [0, 0, 30, 0] },
        axisLabel: { 
          color: "#000",
           formatter: (value) => {
              if (value >= 1000) {
                  return `${value / 1000}k`; 
              }
              return value;
          }, 
      },
      min: 0, 
      }],
      series: [
        {
          name: "ENTREGADOS",
          type: "line",
          smooth: true,
          areaStyle: {},
          itemStyle: { color: "#BBCD21" },
          lineStyle: { opacity: 0.5 },
          symbol: "circle",
          symbolSize: 8,
          data: data.map(item => item.cantidad_entregada),
        },
        {
          name: "REPORTADOS",
          type: "line",
          smooth: true,
          areaStyle: {},
          itemStyle: { color: "#AEAEAE" },
          lineStyle: { opacity: 0.5 },
          symbol: "diamond",
          symbolSize: 10,
          data: data.map(item => item.cantidad_reportada),
        },
      ],
    };
  };
  